/*
  Size guide behaviour, shared by:
  - sections/size-guide.liquid (the Size Guide page)
  - snippets/size-guide-popup.liquid (the popup on product pages)

  Handles the cm/in switch, the size cards, and opening/loading the popup.
*/
(function () {
  if (window.SizeGuide) return;

  var STORAGE_KEY = 'sizeGuideUnit';

  function savedUnit() {
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      return saved === 'cm' || saved === 'in' ? saved : null;
    } catch (e) {
      return null;
    }
  }

  function init(root) {
    if (!root || root.hasAttribute('data-sg-ready')) return;
    root.setAttribute('data-sg-ready', '');

    var unitSwitch = root.querySelector('[data-unit-switch]');

    function setUnit(unit, persist) {
      root.setAttribute('data-unit', unit);
      if (unitSwitch) unitSwitch.setAttribute('aria-checked', unit === 'in' ? 'true' : 'false');
      if (persist) {
        try { localStorage.setItem(STORAGE_KEY, unit); } catch (e) {}
      }
    }

    function setSize(index) {
      root.querySelectorAll('[data-size-col]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-size-col') === String(index));
      });
    }

    if (unitSwitch) {
      unitSwitch.addEventListener('click', function () {
        setUnit(root.getAttribute('data-unit') === 'in' ? 'cm' : 'in', true);
      });
    }

    root.querySelectorAll('.sg__card input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) setSize(input.value);
      });
    });

    if (root.getAttribute('data-remember-unit') === 'true') {
      var saved = savedUnit();
      if (saved) setUnit(saved, false);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.size-guide-section').forEach(init);
  }

  /* ---------- Product page popup ---------- */

  function loadPopup(dialog) {
    if (dialog._sgLoading) return dialog._sgLoading;

    var body = dialog.querySelector('[data-size-guide-body]');
    var url = dialog.getAttribute('data-url');

    dialog._sgLoading = fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Size guide page returned ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.size-guide-section');
        if (!section) throw new Error('No size guide section found on ' + url);

        // The popup shows the size guide only, without the page's side menu.
        section.querySelectorAll('.sg__menu').forEach(function (menu) { menu.remove(); });
        section.querySelectorAll('.sg__layout').forEach(function (el) { el.classList.remove('sg__layout'); });

        body.innerHTML = '';
        body.appendChild(document.importNode(section, true));
        initAll(body);
      })
      .catch(function (error) {
        dialog._sgLoading = null;
        console.error(error);
        var fallback = body.querySelector('[data-size-guide-error]');
        var loading = body.querySelector('[data-size-guide-loading]');
        if (loading) loading.hidden = true;
        if (fallback) fallback.hidden = false;
      });

    return dialog._sgLoading;
  }

  function openPopup(dialog) {
    // Move the popup to <body> so it isn't inside the product form or the variant
    // picker (which some themes re-render on every variant change).
    if (dialog.parentElement !== document.body) {
      document.querySelectorAll('body > .sg-popup').forEach(function (old) {
        if (old !== dialog && old.id === dialog.id) old.remove();
      });
      document.body.appendChild(dialog);
    }
    loadPopup(dialog);
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    // Start at the top each time (only works once the popup is visible).
    var scroller = dialog.querySelector('.sg-popup__scroll');
    if (scroller) scroller.scrollTop = 0;
    document.documentElement.classList.add('sg-popup-open');
  }

  function closePopup(dialog) {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      dialog.dispatchEvent(new Event('close'));
    }
  }

  function findDialog(trigger) {
    // Prefer the popup rendered next to this link, then one already moved to <body>.
    var id = trigger.getAttribute('aria-controls');
    var sibling = trigger.nextElementSibling;
    if (sibling && sibling.classList.contains('sg-popup')) return sibling;
    return (id && document.getElementById(id)) || document.querySelector('.sg-popup');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-size-guide-open]');
    if (trigger) {
      var dialog = findDialog(trigger);
      if (dialog) {
        event.preventDefault();
        dialog._sgTrigger = trigger;
        openPopup(dialog);
      }
      return;
    }

    var close = event.target.closest('[data-size-guide-close]');
    if (close) {
      closePopup(close.closest('.sg-popup'));
      return;
    }

    // Clicking the tinted backdrop (outside the popup box) closes it.
    if (event.target.classList && event.target.classList.contains('sg-popup')) {
      closePopup(event.target);
    }
  });

  // Start loading as soon as the customer shows intent, so the popup opens filled.
  ['pointerenter', 'focusin', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var trigger = event.target.closest && event.target.closest('[data-size-guide-open]');
      if (trigger) {
        var dialog = findDialog(trigger);
        if (dialog) loadPopup(dialog);
      }
    }, { capture: true, passive: true });
  });

  document.addEventListener('close', function (event) {
    var dialog = event.target;
    if (!dialog.classList || !dialog.classList.contains('sg-popup')) return;
    if (!document.querySelector('.sg-popup[open]')) {
      document.documentElement.classList.remove('sg-popup-open');
    }
    if (dialog._sgTrigger) dialog._sgTrigger.focus();
  }, true);

  // Theme editor: re-initialise a section when it's re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  window.SizeGuide = { init: init, initAll: initAll, open: openPopup, close: closePopup };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
